import axios from "axios";

export const state = {
    appusers: [],
};

export const getters = {
    appusers: state => state.appusers,
};

export const mutations = {
    setAppUsers(state, newValue) {
        state.appusers = newValue
    },
};

export const actions = {
    fetchAppUsers({ commit }) {
        axios.get('/appusers').then(res => {
            commit('setAppUsers', res.data.appusers)
        })
    },
};
